import { Options, Vue } from "vue-class-component";
import Toggle from "@vueform/toggle";

import { ProductCategory } from "@/domain/product-category.model";
import { ErrorType } from "@/interfaces/error";

@Options({
  name: "product-category-edit",
  props: {
    id: String,
  },
  components: {
    Toggle,
  },
})
export default class ProductCategoryEdit extends Vue {
  public id: string;
  public errorMessage = "";
  public errors: ErrorType = {};
  public hasError = false;
  public row: ProductCategory = {
    description: "",
    enabled: false,
  };

  public mounted(): void {
    this.$store
      .dispatch("productCategory/get", this.id)
      .then((res: ProductCategory) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = "Registro não encontrado.";
        }
      })
      .catch(() => {
        this.errorMessage = "Registro não encontrado.";
      });
  }

  public goBack() {
    this.$router.push("/product-category");
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = "Este campo deve ser preenchido.";
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      this.$store
        .dispatch("productCategory/update", {
          id: parseInt(this.id),
          description: this.row.description,
          enabled: this.row.enabled,
        })
        .then(() => {
          this.$router.push("/product-category");
        })
        .catch(() => {
          this.errorMessage = "Ocorreu um erro ao gravar o registro.";
        });
    }
  }
}
